import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import requestIcon from '../../../../../img/expiring.png'
import wrenchIcon from '../../../../../img/wrench.png'
import clientIcon from '../../../../../img/group.png'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  hasClient?: any,
  hasRequest?: any,
  hasJob?: any
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  hasClient,
  hasRequest,
  hasJob
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link hover'>
      {hasClient && (
              <span className='menu-icon'>
                <img src={clientIcon} alt='Client' width='21px' height='22px' />
              </span>
            )}
      {hasRequest && (
              <span className='menu-icon'>
                <img src={requestIcon} alt='Request' width='21px' height='22px' />
              </span>
            )}
      {hasJob && (
              <span className='menu-icon'>
                <img src={wrenchIcon} alt='Job' width='21px' height='22px' />
              </span>
            )}
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title text-white'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion text-white', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
